export const Global = {
  API_URL: "https://api.bustanalsukkar.com/api/",
  HostAPI:"https://api.bustanalsukkar.com/",
  PHOTO_URL: "https://api.bustanalsukkar.com/Uploads/",
  bs_api_key:"cY7vB6TpMn8Q3GiUeH1qWoXaArSfZsD2kJw4wS7pV6NjGh8K3AcOyB1kQiRuUlMzTmX2eDq4sO7lR6JfCd8G3WyKuX1gMeNqQhIvPiT2aZm4uQ7nT6"
};
